module.exports = __webpack_public_path__ + "media/images/landing_page/banners/banner_4-8efc7703ba94f873c63effd86db09ee9.jpg";